<!-- @veltra/icons generated sha256:4c6791615ea70bd5 gen:8 source:src/svg/normal/remove.svg -->
<script setup lang="ts">
defineOptions({ name: 'Remove' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M2.987 7h10.026c.552 0 .987.455.987 1.008a.99.99 0 0 1-.987.992H2.987A.995.995 0 0 1 2 7.992C2 7.456 2.435 7 2.987 7"
    />
  </svg>
</template>
